export default [
  {path: '/article', component: () => import('../page/article/index')},
]



// WEBPACK FOOTER //
// ./src/router/article.js